export function ArrowDownIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M8.674 8.5h7.652a1 1 0 01.76 1.65l-3.827 4.464a1 1 0 01-1.518 0l-3.826-4.463a1 1 0 01.76-1.651z"
      ></path>
    </svg>
  );
}
